import script from "./11.ExperienceOilyShine.vue?vue&type=script&setup=true&lang=ts"
export * from "./11.ExperienceOilyShine.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__